import 'core-js/stable'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import {iconsSet as icons} from './assets/icons/icons.js'
import ContactSearcher from './plugins/contact-searcher.js'
import store from './store';
import Toasted from 'vue-toasted';
import VueResource from 'vue-resource';
import vuetify from './plugins/vuetify';
import Vue2Filters from 'vue2-filters'
import money from 'v-money';
import PDatePicker from 'vue2-persian-datepicker'
import VueHotkey from 'v-hotkey'
import {formatDate} from "@/webservice/webservice";

Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.use(Toasted);
Vue.use(VueResource);
Vue.use(Vue2Filters);
Vue.use(money, {precision: 4});
Vue.component('pdatepicker', PDatePicker);
Vue.component('contact-searcher', ContactSearcher);

Vue.use(VueHotkey);

Vue.prototype.$log = console.log.bind(console);
Vue.prototype.$hostname = 'https://api.erp.masterkala.com/1.0.0/?route=';
Vue.prototype.$base_url = 'https://erp.masterkala.com';
Vue.prototype.$isloading = false;


new Vue({
    el: '#app',
    router,
    store,
    icons,
    template: '<App/>',
    vuetify,

    components: {
        App
    }
});
